import { withFormik } from "formik";
import * as yup from 'yup';
import WelcomeMessageForm, { EditWelcomeMessageFormProps, EditWelcomeMessageFormData } from '../../formScenes/WelcomeMessageForm';

const WelcomeMessageContentForm = withFormik<EditWelcomeMessageFormProps, EditWelcomeMessageFormData>({
    mapPropsToValues: props => ({
        responses: [{ content: '' }],
        title: 'Untitled Welcome Message',
        followUpSelection: 'end',
        repromptSelection: 'end',
        sensitiveConversationChange: "None",
        entryType: 'open',
        isLive: true,
        requiresParent: false,
        languages: props.application?.languages.find(l => l.id == props.application?.defaultLanguageId) ? [props.application?.languages.find(l => l.id == props.application?.defaultLanguageId)] : [],
        webhookChainingType: "NoChaining"
    }),
    validationSchema: yup.object().shape({
        title: yup.string().required("You must give this a title"),
        responses: yup.array().of(
            yup.object().shape({
                content: yup.string().required("You must enter a response variation")
            })
        ).required("You must enter at least 1 response variation").min(1, "You must enter at least 1 response variation")
    }),
    validateOnMount: true,
    handleSubmit: (values, { props, setStatus }) => {
        setStatus({
            submitting: true
        });
        return props.onSubmit(props.stateContainer.mapFormDataToModel({
            applicationFeatureId: props.applicationFeatureId,
            applicationId: props.application?.id,
            responses:[]
        }, values));
    }
})(WelcomeMessageForm);

export default WelcomeMessageContentForm;